import { useEffect, useState } from "react";
import { rawMaterials } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";

const AllStocks = () => {
  const [loading, setLoading] = useState(false);
  const [grouped, setGrouped] = useState({});

  const normalizeStock = (data) => {
    const result = [];
    data?.forEach((categoryObj) => {
      const category = Object.keys(categoryObj)[0];
      const rows = categoryObj[category] || [];
      rows.forEach((row) => {
        result.push({
          category,
          sku: row.skU_NO,
          material: row.materiaL_NAME,
          grade: row.grade,
          supplier: row.supplier_Name,
          qty: Number(row.quantity || 0),
          amount: Number(row.amount || 0),
          unit: row.unit_Name,
        });
      });
    });
    return result;
  };

  const groupByCategory = (items) => {
    return items.reduce((acc, item) => {
      (acc[item.category] = acc[item.category] || []).push(item);
      return acc;
    }, {});
  };

  const fetchStock = async () => {
    setLoading(true);
    try {
      const res = await rawMaterials.getAllStock();
      const flat = normalizeStock(res?.data || []);
      setGrouped(groupByCategory(flat));
    } catch (err) {
      notify("Error fetching stock", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchStock();
  }, []);

  return (
    <div>
      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
        <div>
          <h2 className="text-2xl font-extrabold text-gray-800 tracking-tight">
            Stock Inventory
          </h2>
          <p className="text-sm text-gray-500">
            Real-time overview of raw material stock levels.
          </p>
        </div>
      </div>

      {loading ? (
        <Loader />
      ) : Object.keys(grouped).length > 0 ? (
        <div className="space-y-10">
          {Object.keys(grouped).map((cat) => {
            const rows = grouped[cat];

            const totalQty = rows.reduce((t, r) => t + (r.qty || 0), 0);
            const totalAmount = rows.reduce(
              (t, r) => t + Number(r.amount || 0),
              0,
            );
            const avgAmount = totalQty > 0 ? totalAmount / totalQty : 0;

            return (
              <div
                key={cat}
                className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
              >
                <div className="bg-gradient-to-r from-slate-50 to-white px-4 py-2 border-b border-gray-200 flex justify-between items-center">
                  <div>
                    <h3 className="text-lg font-bold text-gray-800 uppercase tracking-wider">
                      {cat}
                    </h3>
                    <p className="text-xs text-gray-400 mt-0.5">
                      {rows.length} Items in this category
                    </p>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="bg-blue-50 px-4 py-2 rounded-xl border border-blue-100">
                      <span className="text-xs font-semibold text-blue-600 uppercase block">
                        Total Qty
                      </span>
                      <span className="text-xl font-bold text-blue-700">
                        {totalQty.toLocaleString()}
                      </span>
                    </div>

                    {/* <div className="bg-orange-50 px-4 py-2 rounded-xl border border-orange-100">
                      <span className="text-xs font-semibold text-orange-600 uppercase block">
                        Total Amount
                      </span>
                      <span className="text-xl font-bold text-orange-700">
                        {totalAmount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div> */}

                    <div className="bg-green-50 px-4 py-2 rounded-xl border border-green-100">
                      <span className="text-xs font-semibold text-green-600 uppercase block">
                        Avg Rate
                      </span>
                      <span className="text-xl font-bold text-green-700">
                        {avgAmount.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="overflow-x-auto">
                  <Table
                    columns={[
                      { key: "sku", label: "SKU" },
                      { key: "material", label: "Material Name" },
                      { key: "grade", label: "Grade" },
                      { key: "supplier", label: "Supplier" },
                      {
                        key: "qty",
                        label: "Qty",
                        render: (val) => <b className="text-gray-900">{val}</b>,
                      },
                      { key: "unit", label: "Unit" },
                    ]}
                    data={rows}
                    showActions={false}
                  />
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="bg-white rounded-2xl border-2 border-dashed border-gray-200 py-20 text-center">
          <div className="text-slate-400 text-6xl mb-4 text-center w-full">
            📦
          </div>
          <h3 className="text-xl font-medium text-gray-600">
            No Stock Data Found
          </h3>
          <p className="text-gray-400 mt-2">
            Try refreshing the page or check back later.
          </p>
        </div>
      )}
    </div>
  );
};

export default AllStocks;
